import { createI18n } from 'vue-i18n'
import { messages, defaultLocale, type SupportedLocale } from '@/locales'

export const i18n = createI18n({
    legacy: false,
    locale: defaultLocale,
    fallbackLocale: defaultLocale,
    messages,
    globalInjection: true,
    missingWarn: false,
    fallbackWarn: false
})

export function setLocale(locale: SupportedLocale) {
    i18n.global.locale.value = locale
}

export function getLocale(): SupportedLocale {
    return i18n.global.locale.value as SupportedLocale
}

export { SupportedLocale }
